import { SelectProps } from "antd";
import { EdObject } from "../../Obj2Tab/EdObject";
import { TreeNode } from "../model/node";
import { ResourceState } from "../model/resourceState";

/**
 * Состояния объекта для выпадающих списков формы.
 * Берутся из уже загруженных данных формы: отдельного запроса за ними нет.
 */
export const stateOptionsOf = (
  formData: ResourceState<unknown>,
  node: TreeNode | undefined,
): SelectProps["options"] | null => {
  if (formData.status !== "ready" || node?.kind !== "object") return null;
  const states = (formData.value as EdObject).states ?? [];
  return states.map(({ id, name }) => ({ value: id, label: name }));
};
